/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Meet_Eu_Ai_ActInputs */



/**
* | output |
* | --- |
* | "Meet EU AI Act requirements" |
*
* @param {Onboarding_Usage_Meet_Eu_Ai_ActInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_meet_eu_ai_act = /** @type {((inputs?: Onboarding_Usage_Meet_Eu_Ai_ActInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Meet_Eu_Ai_ActInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anforderungen der EU-KI-Verordnung erfüllen")
	return /** @type {LocalizedString} */ ("Meet EU AI Act requirements")
});